var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShowersafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 1018.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "showers_after_svg__clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "938.45 587.42 435.98 587.42 435.98 197.48 938.45 198.95 938.45 587.42",
    className: "showers_after_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "showers_after_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1512.83 104.1 417.52 104.1 436.31 -168.14 1531.62 -168.14 1512.83 104.1",
    className: "showers_after_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "showers_after_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1192.69 642.68 -1192.69 883.74 -749.35 867.5 -749.35 630.05 -1192.69 642.68",
    className: "showers_after_svg__cls-1"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n   .showers_after_svg__cls-1,.showers_after_svg__cls-32,.showers_after_svg__cls-34,.showers_after_svg__cls-41{fill:none}.showers_after_svg__cls-12,.showers_after_svg__cls-24,.showers_after_svg__cls-33{fill:#fff}.showers_after_svg__cls-36{fill:#4f4f4e}.showers_after_svg__cls-12,.showers_after_svg__cls-16,.showers_after_svg__cls-17,.showers_after_svg__cls-18,.showers_after_svg__cls-24,.showers_after_svg__cls-25,.showers_after_svg__cls-26,.showers_after_svg__cls-31,.showers_after_svg__cls-32,.showers_after_svg__cls-34,.showers_after_svg__cls-35,.showers_after_svg__cls-36,.showers_after_svg__cls-37,.showers_after_svg__cls-38,.showers_after_svg__cls-41,.showers_after_svg__cls-46,.showers_after_svg__cls-8{stroke:#343a50}.showers_after_svg__cls-12,.showers_after_svg__cls-16,.showers_after_svg__cls-17,.showers_after_svg__cls-18,.showers_after_svg__cls-24,.showers_after_svg__cls-25,.showers_after_svg__cls-26,.showers_after_svg__cls-34,.showers_after_svg__cls-35,.showers_after_svg__cls-36,.showers_after_svg__cls-38,.showers_after_svg__cls-39,.showers_after_svg__cls-46,.showers_after_svg__cls-8{stroke-miterlimit:10}.showers_after_svg__cls-6{fill:#eb9a6b}.showers_after_svg__cls-7{fill:#343a50}.showers_after_svg__cls-8{fill:#7fc3ca;stroke-width:2px}.showers_after_svg__cls-31,.showers_after_svg__cls-32,.showers_after_svg__cls-34,.showers_after_svg__cls-37,.showers_after_svg__cls-41{stroke-linecap:round}.showers_after_svg__cls-31,.showers_after_svg__cls-32,.showers_after_svg__cls-37,.showers_after_svg__cls-41{stroke-linejoin:round}.showers_after_svg__cls-12,.showers_after_svg__cls-32,.showers_after_svg__cls-34,.showers_after_svg__cls-38,.showers_after_svg__cls-46{stroke-width:2px}.showers_after_svg__cls-14{fill:#91bec3}.showers_after_svg__cls-16{fill:#191919}.showers_after_svg__cls-16,.showers_after_svg__cls-17,.showers_after_svg__cls-18,.showers_after_svg__cls-24,.showers_after_svg__cls-25,.showers_after_svg__cls-26,.showers_after_svg__cls-31,.showers_after_svg__cls-35,.showers_after_svg__cls-37,.showers_after_svg__cls-39,.showers_after_svg__cls-41{stroke-width:3px}.showers_after_svg__cls-17{fill:#857d7a}.showers_after_svg__cls-18{fill:#f84c34}.showers_after_svg__cls-25,.showers_after_svg__cls-31{fill:#ffccb5}.showers_after_svg__cls-26{fill:#754e3e}.showers_after_svg__cls-37{fill:#ff5166}.showers_after_svg__cls-35,.showers_after_svg__cls-39{fill:#e0410a}.showers_after_svg__cls-36{stroke-width:3.15px}.showers_after_svg__cls-38{fill:#010101}.showers_after_svg__cls-39{stroke:#fdfeff}.showers_after_svg__cls-46{fill:#7e7e7e}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Unternehmerduschen_Nachher"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "showers_after_svg__Himmel",
    fill: "#a5d1d6",
    points: "472.46 749.66 0 749.66 0 -61.28 434.46 -62.23 472.46 749.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "showers_after_svg__Wolke",
    fill: "#fff",
    d: "M224-67.83c9-21.2 31.84-36.34 58.79-36.34 26.61 0 49.27 14.75 58.51 35.55a48.42 48.42 0 0111.91-1.64c24.31 0 44 17.57 44 39.24s-19.71 39.25-44 39.25H238.78c-24.31 0-44-17.57-44-39.25C194.76-48 207-62.4 224-67.83z",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "showers_after_svg__Boden",
    width: 1261.04,
    height: 269.45,
    x: -1.56,
    y: 750.81,
    fill: "#4f4f4e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Haus_hinten"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 799.4,
    height: 678.22,
    x: -1.01,
    y: 72.87,
    className: "showers_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.4 73.87v676.22H0V73.87h797.4m2-2H-2v680.21h801.4V71.87z",
    className: "showers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 313.17,
    height: 510.36,
    x: 149.63,
    y: 126.78,
    className: "showers_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.59 637.11 288.65 399.54 149.59 399.54 149.59 364.38 288.66 364.38 288.71 126.77 323.82 126.77 323.77 364.38 461.93 364.38 461.93 399.54 323.76 399.54 323.71 637.12 288.59 637.11",
    className: "showers_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.71 127.76h33.12l-.06 235.61v2h138.16v33.17H322.76v2l-.05 235.58h-33.12l.06-235.57v-2H150.59v-33.18h139.07V127.75m-2-2l-.06 237.61H148.59v37.16h139.06v237.57h37.1l.06-237.58h138.12v-37.13H324.77l.05-237.6z",
    className: "showers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 288.04,
    height: 510.36,
    x: 510.55,
    y: 126.78,
    className: "showers_after_svg__cls-8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.11,
    height: 508.36,
    x: 649.58,
    y: 127.78,
    className: "showers_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.69 128.78v506.36h-33.11V128.78h33.11m2-2h-37.11v510.36h37.11V126.78z",
    className: "showers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 286.18,
    height: 35.16,
    x: 511.42,
    y: 364.38,
    className: "showers_after_svg__cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.6 365.37v33.17H512.42v-33.17H796.6m2-2H510.42v37.16H798.6v-37.15z",
    className: "showers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.52,
    height: 589.76,
    x: -1.01,
    y: 161.32,
    fill: "#db8356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.51 162.32v587.77H0V162.32h73.51m2-2H-2v591.76h77.51V160.32z",
    className: "showers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.71,
    height: 553.82,
    x: -1.01,
    y: 197.26,
    fill: "#cc7650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 198.26v551.83H0V198.26h18.7m2-2H-2v555.82h22.7V196.26z",
    className: "showers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.11,
    x2: 19.07,
    y1: 161.9,
    y2: 197.49,
    fill: "#dedede",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.94
  })), /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Haus_vorne"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 872.22,
    height: 932.98,
    x: 386.79,
    y: -62.23,
    className: "showers_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#showers_after_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "436.98 586.42 436.98 198.48 937.45 199.95 937.45 586.42 436.98 586.42",
    className: "showers_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438 199.48l498.47 1.46v384.48H438V199.48m-2-2v389.94h502.45V199L436 197.48z",
    className: "showers_after_svg__cls-7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "937.31 376.76 783.9 376.76 783.9 198.95 755.97 198.95 755.97 376.76 600.95 376.76 600.95 198.95 573.02 198.95 573.02 376.76 437 376.76 437 405.73 573.02 405.73 573.02 585.95 600.95 585.95 600.95 405.73 755.97 405.73 755.97 585.95 783.9 585.95 783.9 405.73 937.31 405.73 937.31 376.76",
    className: "showers_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#showers_after_svg__clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500.14,
    height: 165.37,
    x: 437.32,
    y: -62.26,
    className: "showers_after_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.45-61.26V102.1H438.32V-61.26h498.13m2-2H436.32v167.37h502.13V-63.26z",
    className: "showers_after_svg__cls-7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "601.68 103.03 573.46 103.03 574.46 -62.78 602.68 -62.78 601.68 103.03",
    className: "showers_after_svg__cls-12"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.22,
    height: 165.38,
    x: 755.04,
    y: -62.27,
    className: "showers_after_svg__cls-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Fahrrad"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.98,
    height: 10.01,
    x: -17.28,
    y: 711.82,
    className: "showers_after_svg__cls-16",
    rx: 4.14
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-31.67 763.44 -37.3 758.48 -5.56 716.84 2.04 716.77 -31.67 763.44",
    className: "showers_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.1 757.48 116.35 676.37 125.06 672.84 162.81 753.95 154.1 757.48",
    className: "showers_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.36 862.26a103.62 103.62 0 1173.27-30.35 103 103 0 01-73.27 30.35zm0-198.26A94.63 94.63 0 10254 758.63 94.74 94.74 0 00159.36 664z",
    className: "showers_after_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.36 648.42a113.77 113.77 0 00-82.05 4.83l-7.79-19.17a4.48 4.48 0 00-1-4.41 4.82 4.82 0 00-1.09-.84l-4.75-11.7a4.54 4.54 0 00-.13-3L81.41 575a4.5 4.5 0 10-8.32 3.42l13.64 33.14-162.52 6.06L-85.87 582a4.49 4.49 0 00-5.55-3.1 4.49 4.49 0 00-3.1 5.55l10.41 36.77-35.89 45.54a112.46 112.46 0 00-69.64-23.93 112.7 112.7 0 00-80.51 33.59 114.3 114.3 0 00-33.33 81.06 5.63 5.63 0 005.63 5.63 5.63 5.63 0 005.63-5.63c0-57 46-103.39 102.58-103.39A101.52 101.52 0 01-127 675.65l-66 83.64a4.5 4.5 0 00-.57 4.65 4.5 4.5 0 003.87 2.63l146.28 7.36h.23a3.55 3.55 0 00.46 0h.61l.31-.08.14-.05.31-.13h.12a3.07 3.07 0 00.31-.17l.1-.06a2.7 2.7 0 00.33-.22h.06l.35-.29L99.35 639.81l6.72 16.54a114.94 114.94 0 00-60.35 101.27 5.63 5.63 0 0011.26 0c0-57 46-103.39 102.59-103.39a101.74 101.74 0 0131.33 4.91 5.63 5.63 0 103.46-10.72zm-314.55 33.06a103.53 103.53 0 0133.11 76 5.62 5.62 0 004.31 5.52l-97.85-5zm39.49 81.57a5.63 5.63 0 004.88-5.57 114.34 114.34 0 00-33.33-81.06q-2-2-4-3.85l31.82-40.3 32.27 132.38zm40-2.23l-32.78-134.29 164.94-6.16 4.26 10.49z",
    className: "showers_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.36,
    cy: 758.63,
    r: 8.97,
    className: "showers_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16 852.88a95.29 95.29 0 1195.28-95.29 95.39 95.39 0 01-95.28 95.29zm0-181.47a86.19 86.19 0 1086.19 86.18 86.29 86.29 0 00-86.19-86.18zM91.64 500.21c.58-.56-2.33 3.55-3.42 7.44l-18 62-48 37c-3.28 2.34-6.35 2.72-4 6 1.42 2 1.33 1.94 3.6 1.94a7.29 7.29 0 004.25-1.37l46.84-33.6 6.35 14.93 9.31-4-8.87-20.82 17-60.52c1.08-3.88-7.93-6.21-5.06-9z",
    className: "showers_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.92,
    x2: 92.5,
    y1: 528.17,
    y2: 500.66,
    className: "showers_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.81 532.15l-11.09-5.09 4.64-21.91c1-4.51 4.21-7 7.28-5.62 3.06 1.41 4.77 6.2 3.81 10.71z",
    className: "showers_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.44,
    x2: 22.22,
    y1: 596.74,
    y2: 610.65,
    className: "showers_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.66 592.83l4.66 10.7-16.95 11.61c-3.48 2.38-7.35 1.92-8.64-1-1.28-3 .5-7.29 4-9.68z",
    className: "showers_after_svg__cls-18"
  })), /*#__PURE__*/React.createElement("path", {
    id: "showers_after_svg__Fahrradst\\xE4nder",
    fill: "#515151",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M23.07 878.61h-.58c-7.17-.28-12.73-5.67-12.41-12.05a168.49 168.49 0 0112.28-52.62c13.7-33.63 37.36-60.39 68.44-77.41 46.86-25.66 93.79-30.35 132.15-13.19 47.9 21.42 74.53 72.15 66.27 126.22-1 6.33-7.52 10.75-14.63 9.9s-12.1-6.68-11.13-13c6.76-44.31-14.21-85.49-52.2-102.48-40.47-18.11-84.3-.12-106.82 12.22-62.81 34.39-68 103.6-68.39 111.38-.31 6.19-6.05 11.03-12.98 11.03z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "showers_after_svg__Posten",
    width: 21,
    height: 933.06,
    x: 386.8,
    y: -62.31,
    fill: "#815c2a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Schild"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bf786a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M1182 325.49h-169.5a8.57 8.57 0 01-8.57-8.57v-50.27a8.57 8.57 0 018.57-8.56H1182l49.15 22.56a10.2 10.2 0 01.56 18.27z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Lato-Regular,Lato",
    fontSize: 42,
    letterSpacing: 0,
    transform: "translate(1027.18 304)"
  }, "\r\n      D", /*#__PURE__*/React.createElement("tspan", {
    x: 28.1,
    y: 0
  }, "uschen")), /*#__PURE__*/React.createElement("path", {
    d: "M1088.29 220.6l-23.83 37.49z",
    className: "showers_after_svg__cls-24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120.5,
    x2: 1090.2,
    y1: 258.09,
    y2: 220.6,
    className: "showers_after_svg__cls-24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1089.31,
    cy: 217.13,
    r: 6.47,
    className: "showers_after_svg__cls-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Mann"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M725 855.06a249.71 249.71 0 01-7.34-43.86 246.44 246.44 0 010-37.41l17.63-15.48A61.75 61.75 0 01747 775.08c5.87 12.5 4.78 22.21 4.41 49-.09 6.94-.18 17.65 0 31",
    className: "showers_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.58 493.21c-7.25-1.25-15.44 5.29-19.35 10.32-7.61 9.78-3.26 19.32-3.87 47.73-.42 19.43-2.53 18.31-2.58 37.41-.07 22.09 0 33.32 6.45 42.57 7.63 11 24.33 21.18 34.83 16.77 30.32-12.75 14.26-149.67-15.48-154.8z",
    className: "showers_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.29 854.71a249.71 249.71 0 01-7.29-43.86 246.44 246.44 0 010-37.41L793.58 758a61.91 61.91 0 0111.75 16.77c5.87 12.51 4.78 22.21 4.41 49-.09 6.94-.18 17.65 0 31",
    className: "showers_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f4a74",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "719.03 649.3 806.58 647.37 810.56 777.29 771.65 779.26 754.29 684.28 754.29 773.91 712.41 775.96 712.41 648.65 719.03 649.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M806.58 646.08L818.84 506a16.63 16.63 0 00-16.63-16.62h-88A16.62 16.62 0 00697.58 506l14.83 141.41 74.16-1c7.74-.25 20.33 3.59 20.01-.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.89 472.57c-.57 2.79-3.71 19.48 6.45 29.67a22.73 22.73 0 005.16 3.87l2.58-1.29c2.07-1.41 9.54-6.87 11.61-16.77a25.76 25.76 0 000-10.32",
    className: "showers_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 759.5,
    x2: 757.56,
    y1: 506.11,
    y2: 648.01,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M827.87 372c.06-1-1.68-1.31-3.87-3.87-2.71-3.16-2.3-5.28-3.87-6.45-1.06-.78-2.91-1.05-6.33.33a45.74 45.74 0 00-11.72-12.27c-9.19-6.95-18.23-8.62-26-10.06a81.81 81.81 0 00-28.55 0c-1.4-2.6-3.77-5.65-7.39-6.39-.57-.11-4.45-.84-6.45 1.29-1 1.09-1.05 2.39-1.29 3.87a20.25 20.25 0 01-2.13 6.18 38.12 38.12 0 00-4.5 2.58 45 45 0 00-14.26 15.93c-3.06 5.49-4.17 10-5.86 16.77-.53 2.09-1.45 5.93-2.22 11a10.87 10.87 0 00-.86 18.85c.21 1.94.46 3.68.56 5.34l10.06.84 8.39-24.32L735 377.16l15.93 4.39 15.94 10.9 20.08 7.2 23.7 18 9-2.52c-.06-6.76 0-9.26.07-13.88.08-8.81.22-11-.07-15.47-.27-4.16-.49-7.44-1-10.45 7.45-1.21 9.16-2.43 9.22-3.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.25 442.28c-8-1.63-14-7.18-14-13.77 0-6.44 5.65-11.88 13.41-13.65M811.52 442.41c8.05-1.62 14-7.17 14-13.77 0-6.44-5.65-11.88-13.41-13.65",
    className: "showers_after_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.71 363.1a49.66 49.66 0 00-14.25 7.55c-15 12.53-16.57 32-16.77 37.73v4.2c0 11-.16 23.58.83 32.7a44 44 0 00.84 5 47 47 0 002.52 7.54c3.6 8 11.87 14.55 12.58 15.1a50.64 50.64 0 0020.12 9.22c6.06 1.45 16.36 4.05 27.67 0 2.77-1 5.62-2.76 11.32-6.29A87.3 87.3 0 00805.86 460c2.88-3.26 4.66-5.88 5-9.22.11-1.07 0-1.72 0-5.87v-6.71c0-4.56.3-19 .84-38.57a48.37 48.37 0 00-5-2.52 46.88 46.88 0 00-7.54-2.51c-7.3-1.83-20.87-9.74-38.57-20.13-5.56-3.25-10-5.93-15.1-9.22-4-2.6-7.44-4.9-10.06-6.71",
    className: "showers_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.62 398.32a12 12 0 016.71-4.19 12.47 12.47 0 0110.06 2.51M779.05 399.65a12 12 0 016.71-4.19 12.47 12.47 0 0110.06 2.54M748.42 457a25.33 25.33 0 008.38 3.35 24.83 24.83 0 0010.07 0 24.06 24.06 0 009.22-4.19M754.29 439.41a7.56 7.56 0 0014.25 0",
    className: "showers_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 735,
    cy: 417.19,
    className: "showers_after_svg__cls-33",
    rx: 8.39,
    ry: 6.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.83,
    cy: 417.19,
    className: "showers_after_svg__cls-33",
    rx: 8.39,
    ry: 6.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 734.58,
    cy: 417.61,
    className: "showers_after_svg__cls-7",
    rx: 2.93,
    ry: 4.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 787.41,
    cy: 416.77,
    className: "showers_after_svg__cls-7",
    rx: 2.93,
    ry: 4.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 426a9.34 9.34 0 015.87-.84M816.34 433.54A3.94 3.94 0 00818 431c.35-2.35-2.21-4-2.51-4.19a6.16 6.16 0 00-4.19-.84",
    className: "showers_after_svg__cls-34"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.32 838.8 751.76 838.8 751.76 851.39 737.57 858.28 728.54 855.7 724.5 853.19 721.32 838.8",
    className: "showers_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "780.01 838.28 810.45 838.28 810.45 850.88 796.26 857.77 787.23 855.19 783.2 852.67 780.01 838.28",
    className: "showers_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.27 869.88c0-11.84 9.09-23.21 20.31-23.21S816.9 858 816.9 869.88",
    className: "showers_after_svg__cls-24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 774.97,
    x2: 816.9,
    y1: 868.88,
    y2: 868.61,
    className: "showers_after_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.76 869.77c0-11.84 9.09-21.54 20.32-21.54s20.39 9.81 20.39 21.65",
    className: "showers_after_svg__cls-24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 717.3,
    x2: 760.89,
    y1: 870.16,
    y2: 870.16,
    className: "showers_after_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.57 625c-3.92 3.61-5.15 8.16-6.37 13-1.4 5.48-2.1 8.21-1.21 10.65 1.86 5.11 8.37 9 13.29 7.8 7.46-1.83 9.77-14.77 10.37-14.77.44 0-.23 6.75 2.53 11.42.78 1.34 1.86 3 3.89 2.14 3.77-1.53 1.82-4 1.54-6.59-.38-3.66-.07-4.25-.66-7.57-.85-4.82.19-5.87-1-9.11-.5-1.39-3.37-3.11-9.11-6.48-5-2.92-6.36-3.54-8.23-3.29a9.14 9.14 0 00-5.04 2.8z",
    className: "showers_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "700.18 497.84 696.95 507.25 676.46 623.77 700.18 633.41 718.22 531.91",
    className: "showers_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 496.71l4.66 8.79L859 617.43l-4 2.37-18 10.83q-16.78-48.74-33.58-97.47",
    className: "showers_after_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.76 486.71a2.31 2.31 0 010 2c-1.62 39.7-7.5 70.29-12.9 91.59-1.16 4.58-7.77 30.64-10.32 30.19-1.72-.31-1-12.62 0-23.74a249.89 249.89 0 007.74-96.75 3.07 3.07 0 010-2.58c.46-.78 1.33-1.06 2.58-1.29 3.56-.67 4.71.08 9 0 2.04-.05 3.35-.25 3.9.58z",
    className: "showers_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.31 613.83c1.71.83 3.72 3.56 7.74 9 3.4 4.62 3.73 5.8 3.87 6.45 1.28 5.9-3.48 11.18-3.87 11.61-4.34 4.68-12.25 7-18.06 3.87-5.41-2.91-6.58-9.21-7.74-15.48-.73-4-1.18-6.37 0-9 2.75-6.17 12.27-9.28 18.06-6.45z",
    className: "showers_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.59 703.63a25.94 25.94 0 01-9.4 4.12 26.35 26.35 0 01-5.5.54 70.74 70.74 0 00-14.2 1.85v-1.55c0-.81-.41-3.25-1.17-8.12-.66-4.23-.84-4.89-1.1-6.92a67.61 67.61 0 01-.52-9.6l-4 1.18a91.88 91.88 0 00.79 14.4c.74 5.54 1.47 7.19 1.51 10 .06 4.35-1.5 10.56-9.11 18.31l3.58 3.89a22.15 22.15 0 002.06-2 26 26 0 004.62-8 54.94 54.94 0 002.88-8.25h3.64c10.82-.21 15.45-.93 18.21-1.48a26.08 26.08 0 007.83-2.74c.92-.51 1.64-1 2.13-1.32z",
    className: "showers_after_svg__cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.94 711.45c3.14-1.73 5.39-4.3 7.94-8.86 4.11-7.33 9.74-17.38 7.25-30.23a37.1 37.1 0 00-5.8-13.64c-7.42-10.8-18.92-15-23.77-16.75-3.76-1.37-3.73-.9-9.3-2.86-6.19-2.17-8.4-3.51-16.49-6.56-7.23-2.73-9-3-9.79-3.07a32.27 32.27 0 00-12.21 1.14 44.68 44.68 0 00-12.72 5c-7.62 4.53-17.38 13.59-15.32 19.13a5 5 0 001 1.62 4.81 4.81 0 002.12 1.21 133.35 133.35 0 0118.24 7.91c4.16 2.3 5.38 3.77 5.76 4.26a19.23 19.23 0 013.29 7.28c.2 1 .12 1 .34 1.9a13.63 13.63 0 002.73 5.87c2.75 3 7.14 2.94 8.1 2.93 3.41-.06 3.91-1.49 8-2.37a23.2 23.2 0 019.88.18c2.65.65 8 2 10.7 6.4 1.15 1.92 1.6 4.76 2.49 10.45.4 2.51.44 3.61 1.25 5.22a11.2 11.2 0 005.34 5.25c4.76 2.01 9.44-.57 10.97-1.41z",
    className: "showers_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 836.86,
    cy: 644.07,
    className: "showers_after_svg__cls-38",
    rx: 7.25,
    ry: 2.69,
    transform: "rotate(-56.27 836.807 644.064)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 864.7,
    cy: 677.81,
    r: 2.69,
    className: "showers_after_svg__cls-38"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.43,
    cy: 701.75,
    r: 2.69,
    className: "showers_after_svg__cls-38"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 902.93,
    cy: 653.1,
    className: "showers_after_svg__cls-38",
    rx: 2.69,
    ry: 9.4,
    transform: "rotate(-32.43 902.818 653.062)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 888.77,
    cy: 646.16,
    className: "showers_after_svg__cls-38",
    rx: 2.69,
    ry: 7.85,
    transform: "rotate(-32.43 888.666 646.131)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 874.9,
    cy: 639.43,
    className: "showers_after_svg__cls-38",
    rx: 1.84,
    ry: 7.75,
    transform: "rotate(-32.43 874.794 639.393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.09 632.59l3 14.78a2.56 2.56 0 00.24 1.18 3.59 3.59 0 004.48 1.49 3.94 3.94 0 001.87-2.63c.44-1.57.07-2.89-.55-4.94-.81-2.72-1.43-3.06-1.76-5.16a6.45 6.45 0 01.11-3.63c.43-1 1.54-2.32 5.71-3.18 7.73-1.6 12.64 1.25 14-.77.56-.87.08-2.09-.77-4.28a16.34 16.34 0 00-4.17-6",
    className: "showers_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 728.17,
    cy: 843.22,
    className: "showers_after_svg__cls-39",
    rx: 2.42,
    ry: 7.79,
    transform: "rotate(-60 728.173 843.228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 845.84c-.45-1.26 2.48-3.45 6.53-4.9s7.7-1.6 8.15-.34-2.47 3.46-6.52 4.9-7.68 1.6-8.16.34z",
    className: "showers_after_svg__cls-39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 786.87,
    cy: 843.22,
    className: "showers_after_svg__cls-39",
    rx: 2.42,
    ry: 7.79,
    transform: "rotate(-60 786.868 843.225)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 803.07,
    cy: 843.22,
    className: "showers_after_svg__cls-39",
    rx: 7.79,
    ry: 2.42,
    transform: "rotate(-19.64 803.163 843.284)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#754e3e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.4,
    d: "M674.37 539.15a17.47 17.47 0 006.64.68 18.7 18.7 0 0011.41-5.61"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 737.52,
    x2: 719.75,
    y1: 602.14,
    y2: 624.67,
    className: "showers_after_svg__cls-41"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 778.94,
    x2: 796.71,
    y1: 602.62,
    y2: 625.15,
    className: "showers_after_svg__cls-41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M970 923.24h-3.95c-22.89 0-41.52-11.85-41.52-26.41 0-12.08 12.74-22.47 30.76-25.51-5.06-4.47-7.81-9.85-7.81-15.43 0-12 12.38-22.27 30.34-25.42A17.26 17.26 0 01977 825c0-13 14.29-23.75 34.17-26 .88-14.08 19.15-25.36 41.49-25.36a64.47 64.47 0 0111.44 1c7.72-7.33 20.53-11.68 34.47-11.68a59.91 59.91 0 0122.44 4.17c7.12-6.48 18.61-10.63 31.09-11.19 7.68-7.51 20.62-12 34.76-12 22.49 0 40.86 11.44 41.5 25.65 14.39 2.18 26 9.22 30.11 18.25h.19c20.16 0 37 8.91 40.73 21.36 20 .21 36.6 9.19 40.11 21.65 16.66 3.69 27.78 13.63 27.78 24.93 0 6.45-3.54 12.5-10.06 17.28 14.09 4.42 23 13.49 23 23.66 0 12-12.74 22.51-31 25.53h-.12l-377 .86c-.63.06-1.27.09-2 .09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.82 745.46c22.1 0 40 11.16 40 24.92v.53c15.09 2 27 9.21 30.65 18.49h1.17c20.17 0 36.81 9.3 39.58 21.37h.45c20.2 0 36.85 9.32 39.58 21.43 16 3.27 27.51 12.62 27.51 23.65 0 7-4.64 13.31-12.1 17.84 14.68 3.69 25 12.63 25 23.1 0 11.54-12.62 21.22-29.73 24l-377 .86q-1 .09-2 .09c-1.28 0-2.56-.09-3.94-.09-22.1 0-40-11.15-40-24.91 0-12.26 14.22-22.42 32.94-24.51-6.2-4.38-10-10.12-10-16.43 0-11.8 13.2-21.66 30.9-24.24a16.24 16.24 0 01-1.47-6.6c0-12.52 14.85-22.85 34.16-24.62v-.3c0-13.76 17.92-24.92 40-24.92a62.81 62.81 0 0111.93 1.13c7.06-7.08 19.62-11.8 34-11.8a57.89 57.89 0 0122.76 4.43c6.71-6.55 18.19-11 31.41-11.48 7-7.15 19.66-11.94 34.12-11.94m0-3c-14.27 0-27.39 4.47-35.4 12-12.19.65-23.45 4.67-30.75 10.93a61.59 61.59 0 00-22.14-3.94c-14 0-26.91 4.3-35 11.58a66.08 66.08 0 00-11-.91c-11.24 0-21.85 2.76-29.88 7.75-7.59 4.73-12.12 11-13 17.77-20 2.62-34.29 13.85-34.29 27.32a18.22 18.22 0 00.51 4.25C958.17 832.83 946 843.45 946 855.8c0 5.18 2.17 10.18 6.2 14.51-17.23 3.75-29.15 14.27-29.15 26.43 0 7.73 4.66 14.89 13.14 20.16 8 5 18.64 7.75 29.88 7.75h3.94c.66 0 1.44 0 2.09-.09l376.84-.86h.48c19-3.14 32.24-14.25 32.24-27 0-10.19-8.23-19.29-21.44-24.19 5.52-4.77 8.49-10.57 8.49-16.75 0-11.82-11.21-22.2-28.1-26.19-4.12-12.42-20.46-21.36-40.2-21.87-4.47-12.37-21.15-21.16-41.07-21.37-4.54-9-15.57-15.67-29.64-18.06-.76-6.93-5.31-13.3-13-18.1-8-5-18.64-7.75-29.88-7.75z",
    className: "showers_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dedede",
    d: "M943.91 908.31c0-12.26 14.22-22.42 32.94-24.51-6.2-4.39-10-10.13-10-16.43 0-11.8 13.2-21.66 30.9-24.24a16.28 16.28 0 01-1.47-6.61c0-12.51 14.84-22.85 34.16-24.61v-.3c0-13.76 17.92-24.92 40-24.92a62.7 62.7 0 0111.92 1.13c7.06-7.08 19.62-11.81 34-11.81a57.89 57.89 0 0122.76 4.44c6.71-6.55 18.19-11 31.41-11.48 7-7.15 19.66-11.94 34.12-11.94a60.11 60.11 0 0118.39 2.8c-6.38-8.48-20.18-14.37-36.22-14.37-14.46 0-27.09 4.79-34.12 11.94-13.22.48-24.7 4.93-31.41 11.48a57.89 57.89 0 00-22.76-4.43c-14.36 0-26.92 4.72-34 11.8a62.81 62.81 0 00-11.93-1.13c-22.1 0-40 11.16-40 24.92v.3c-19.31 1.77-34.16 12.1-34.16 24.62a16.24 16.24 0 001.47 6.6C962.23 834.14 949 844 949 855.8c0 6.31 3.79 12.05 10 16.43-18.72 2.09-32.94 12.25-32.94 24.51 0 9.63 8.79 18 21.63 22.11a17.42 17.42 0 01-3.78-10.54z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Unternehmerduschen_Vorher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Haus-vorne"
  }, /*#__PURE__*/React.createElement("g", {
    id: "showers_after_svg__Mauer",
    clipPath: "url(#showers_after_svg__clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: -47.13,
    y: 642.65,
    className: "showers_after_svg__cls-46"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.68,
    height: 55.71,
    x: -47.13,
    y: 754.06,
    className: "showers_after_svg__cls-46"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowersafter);
export default __webpack_public_path__ + "static/media/showers.after.cfb21e54.svg";
export { ForwardRef as ReactComponent };